import * as Yup from 'yup';
import { errorMessages } from '~/constants/errorMessages.ts';

export const mainPageSchema = Yup.object({
  dataUpdateForms: Yup.array()
    .of(
      Yup.object({
        label: Yup.string().required(),
        value: Yup.mixed().required(),
      })
    )
    .min(1, errorMessages.ANSWER_OPTION)
    .required(),
});
